import React from 'react';
import { ContentSection, Heading } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { EarlySettlementFigure } from '../../components/early-settlement-figure';
import { useParams } from 'react-router-dom';

export const EarlySettlementPage: React.FC = () => {
    const { t } = useTranslation('early-settlement');
    const title = t('headline');
    const params = useParams<{ encryptedContractNumber?: string }>();

    return (
        <ContentSection pageWrapSize="medium">
            <Heading level={1}>{title}</Heading>

            <EarlySettlementFigure encryptedContractNumber={params.encryptedContractNumber} />
        </ContentSection>
    );
};
